import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalVariant } from '@patternfly/react-core';
import { useKeycloak } from '@project/auth/keycloakInstance';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  timeLeft: number;
}

export const SessionWarningModal: React.FC<Props> = ({ isOpen, timeLeft }) => {
  const { keycloak, logout } = useKeycloak();
  const { t } = useTranslation();

  const handleExtend = () => {
    // Calling updateToken with -1 forces a refresh of the SSO session
    keycloak.updateToken(-1);
  };

  return (
    <Modal
      variant={ModalVariant.small}
      isOpen={isOpen}
      onClose={handleExtend}
      aria-label={t('sessionWarningModal.ariaLabel', 'Session expiration warning')}
    >
      <ModalHeader
        title={t('sessionWarningModal.title', 'Session Expiring')}
        titleIconVariant="warning"
      />
      <ModalBody>
        <div
          aria-live="polite"
          aria-atomic="true"
          className="pf-v6-u-screen-reader"
        >
          {timeLeft % 10 === 0 && t('sessionWarningModal.screenReader', { timeLeft, defaultValue: 'You will be logged out in {{timeLeft}} seconds.' })} 
        </div>
        {t('sessionWarningModal.description', { timeLeft, defaultValue: 'Your session is about to expire due to inactivity. You will be logged out in <strong>{{timeLeft}}</strong> seconds.' })} 
      </ModalBody>
      <ModalFooter>
        <Button key="confirm" variant="primary" onClick={handleExtend}>
          {t('sessionWarningModal.stayLoggedIn', 'Stay Logged In')}
        </Button>
        <Button key="cancel" variant="link" onClick={() => logout()}>
          {t('sessionWarningModal.logOut', 'Log Out')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

